import { render, staticRenderFns } from "./materialInfo.vue?vue&type=template&id=63e53e9e&scoped=true&"
import script from "./materialInfo.vue?vue&type=script&lang=js&"
export * from "./materialInfo.vue?vue&type=script&lang=js&"
import style0 from "./materialInfo.vue?vue&type=style&index=0&id=63e53e9e&prod&lang=scss&scoped=true&"
import style1 from "./materialInfo.vue?vue&type=style&index=1&id=63e53e9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e53e9e",
  null
  
)

export default component.exports